<template>
  <div class="col-md-12" style="border: 1px solid black">
    <h4>Animals for Purchase:
     <b-btn
          class="btn-danger float-right"
           style="text-align: right;"
          @click="back()"
        >
         <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
        </b-btn></h4>
    <hr />
    <div class="col-md-12">
      <b-tabs>
        <template #tabs-end>
          <b-nav-item
            href="#"
            role="presentation"
            @click="handleCategoryCow"
            style="border: 1px solid black; border-radius: 40px"
            >Cow</b-nav-item
          >&nbsp;&nbsp;
          <b-nav-item
            href="#"
            role="presentation"
            @click="handleCategoryBuffalo"
            style="border: 1px solid black; border-radius: 100px"
            >Buffalo</b-nav-item
          >&nbsp;&nbsp;
          <b-nav-item
            href="#"
            role="presentation"
            @click="handleCategoryGoat"
            style="border: 1px solid black; border-radius: 40px"
            >Goat</b-nav-item
          >&nbsp;&nbsp;
          <b-nav-item
            href="#"
            role="presentation"
            @click="handleCategoryOx"
            style="border: 1px solid black; border-radius: 40px"
            >Ox</b-nav-item
          >
          
        </template>
      </b-tabs>
    </div>&nbsp;
    <div class="row">
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 ">
           <b-card
                style="max-width: 20rem;"
                class="mb-2"
            >
                <b-card-text @click="handleDetails">
                    <img src="../assets/123.jpg" height="200px" width="150px" style="object-fit: cover;padding-right:15px;">
                </b-card-text>
                  <table>
                  <tr>
                    <th>Name:</th>
                    <td>Buffalo</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>8</td>
                  </tr>
                   <tr>
                    <th>Amount:</th>
                    <td>10000</td>
                  </tr>
                </table>
                <center> 
                    <b-button @click="handlewishlist" variant="success">
                        <b-icon-heart></b-icon-heart>
                    </b-button>
                    &nbsp;
                    <b-button @click="handlecart" variant="danger">
                        <b-icon-cart></b-icon-cart>
                    </b-button>
                </center>
            </b-card>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6" style="height:200px">
            <b-card
                style="max-width: 20rem;"
                class="mb-2"
            >
                <b-card-text @click="handleDetails">
                      <img src="../assets/123.jpg" height="200px" width="150px" style="object-fit: cover; padding-right:15px;">
                </b-card-text>
                  <table>
                  <tr>
                    <th>Name:</th>
                    <td>Buffalo</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>8</td>
                  </tr>
                   <tr>
                    <th>Amount:</th>
                    <td>10000</td>
                  </tr>
                </table>
                <center> 
                    <b-button @click="handlewishlist" variant="success">
                        <b-icon-heart></b-icon-heart>
                    </b-button>
                    &nbsp;
                    <b-button @click="handlecart" variant="danger">
                        <b-icon-cart></b-icon-cart>
                    </b-button>
                </center>
            </b-card>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 ">
            <b-card
                style="max-width: 20rem;"
                class="mb-2"
            >
                <b-card-text @click="handleDetails">
                      <img src="../assets/123.jpg" height="200px" width="150px" style="object-fit: cover; padding-right:15px;">
                </b-card-text>
                  <table>
                  <tr>
                    <th>Name:</th>
                    <td>Buffalo</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>8</td>
                  </tr>
                   <tr>
                    <th>Amount:</th>
                    <td>10000</td>
                  </tr>
                </table>
                <center> 
                    <b-button @click="handlewishlist" variant="success">
                        <b-icon-heart></b-icon-heart>
                    </b-button>
                    &nbsp;
                    <b-button @click="handlecart" variant="danger">
                        <b-icon-cart></b-icon-cart>
                    </b-button>
                </center>
            </b-card>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 ">
            <b-card
                style="max-width: 20rem;"
                class="mb-2"
            >
               <b-card-text @click="handleDetails">
                      <img src="../assets/123.jpg" height="200px" width="150px" style="object-fit: cover; padding-right:15px;">
                </b-card-text>
                  <table>
                  <tr>
                    <th>Name:</th>
                    <td>Buffalo</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>8</td>
                  </tr>
                   <tr>
                    <th>Amount:</th>
                    <td>10000</td>
                  </tr>
                </table>
                <center> 
                    <b-button @click="handlewishlist" variant="success">
                        <b-icon-heart></b-icon-heart>
                    </b-button>
                    &nbsp;
                    <b-button @click="handlecart" variant="danger">
                        <b-icon-cart></b-icon-cart>
                    </b-button>
                </center>
            </b-card>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 ">
            <b-card
                style="max-width: 20rem;"
                class="mb-2"
            >
                <b-card-text @click="handleDetails">
                      <img src="../assets/123.jpg" height="200px" width="150px" style="object-fit: cover; padding-right:15px;">
                </b-card-text>
                  <table>
                  <tr>
                    <th>Name:</th>
                    <td>Buffalo</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>8</td>
                  </tr>
                   <tr>
                    <th>Amount:</th>
                    <td>10000</td>
                  </tr>
                </table>
                <center> 
                    <b-button @click="handlewishlist" variant="success">
                        <b-icon-heart></b-icon-heart>
                    </b-button>
                    &nbsp;
                    <b-button @click="handlecart" variant="danger">
                        <b-icon-cart></b-icon-cart>
                    </b-button>
                </center>
            </b-card>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 ">
            <b-card
                style="max-width: 20rem;"
                class="mb-2"
            >
                <b-card-text @click="handleDetails">
                      <img src="../assets/123.jpg" height="200px" width="150px" style="object-fit: cover; padding-right:15px;">
                </b-card-text>
                  <table>
                  <tr>
                    <th>Name:</th>
                    <td>Buffalo</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>8</td>
                  </tr>
                   <tr>
                    <th>Amount:</th>
                    <td>10000</td>
                  </tr>
                </table>
                <center> 
                    <b-button @click="handlewishlist" variant="success">
                        <b-icon-heart></b-icon-heart>
                    </b-button>
                    &nbsp;
                    <b-button @click="handlecart" variant="danger">
                        <b-icon-cart></b-icon-cart>
                    </b-button>
                </center>
            </b-card>
        </div>
        
    </div>
    <div class="row">
        <div class="col-12">
            <center>
                <b-button class="text-center" variant="primary" @click="handleCertficate" style="margin:20px;padding:15px">Request For Transport Certificate</b-button>
            </center>
        </div>
    </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
       back(){
          this.$router.go("-1");
      },
    handleCategoryCow(){
        this.$router.push('/cowdetails');
    },
     handleCategoryBuffalo(){
        this.$router.push('/buffelodetails');
    },
     handleCategoryGoat(){
        this.$router.push('/goatdetails');
    },
     handleCategoryOx(){
        this.$router.push('/oxdetails');
    },
    handlecart(){
        alert("Added To Cart");
    },
    handlewishlist(){
        alert("Added To Wishlist");
    },
    handleDetails(){
        this.$router.push('/productdetails');
    },
    handleCertficate(){
        this.$router.push('/transportcertificate');
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-light", "text-info"];
      }
    },
  },
};
</script>
